"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLToolbar = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useSelection_1 = __importDefault(require("@opsbase/web-data-selection/useSelection"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importStar(require("react"));
const FiltersBar_1 = __importDefault(require("../FiltersBar"));
const GroupersMenu_1 = __importDefault(require("../GroupersMenu"));
const MoreMenu_1 = __importDefault(require("../MoreMenu"));
const OpsMenu_1 = __importDefault(require("../OpsMenu"));
const makeMyClasses = (hasSelected, loading) => ({
    root: {
        position: 'relative',
        overflow: 'visible',
        pointerEvents: loading ? 'none' : 'unset',
        transition: 'opacity 0.15s',
    },
    selectToolbar: {
        position: 'absolute',
        zIndex: 1,
        minHeight: 42,
        top: hasSelected ? 4 : -49,
        transition: 'top 0.3s',
    },
    mainToolbar: {
        overflow: 'visible',
        minHeight: 42,
        opacity: hasSelected ? 0 : 1,
        pointerEvents: hasSelected ? 'none' : undefined,
        transition: 'opacity 0.15s',
    },
});
function DVLToolbar(props) {
    const { selectionToolbar, disableFieldSelection = false, additionalMoreButtons, disableGrouping = false, disableCharts = false, disableSaving = false, disableOpsMenu = false, fieldSelector, } = props;
    const dt = (0, useDataTree_1.default)();
    const { app } = (0, useAppState_1.default)();
    const { type: dataType } = (0, useView_1.default)(dt.viewId);
    const { selecteds } = (0, useSelection_1.default)(dataType);
    const hasSelected = !!selecteds.length;
    const myCss = (0, web_css_1.default)(makeMyClasses, [hasSelected, dt.dataStatus.loadingItems]);
    const showOpsMenu = !disableOpsMenu && dataType === DataType_1.default.OP && app === App_1.default.OPSBASE;
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.selectToolbar } },
            react_1.default.createElement(Pane_1.default, null, selectionToolbar),
            react_1.default.createElement(Pane_1.default, { grow: true })),
        react_1.default.createElement(Horizontal_1.default, { gutter: true, classes: { root: myCss.mainToolbar } },
            showOpsMenu && (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true },
                react_1.default.createElement(OpsMenu_1.default, null))),
            react_1.default.createElement(Pane_1.default, { grow: true, visible: true },
                react_1.default.createElement(FiltersBar_1.default, { filterableSelector: fieldSelector })),
            !disableGrouping && (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true },
                react_1.default.createElement(GroupersMenu_1.default, { groupableSelector: fieldSelector }))),
            react_1.default.createElement(Pane_1.default, { shrink: true, visible: true },
                react_1.default.createElement(MoreMenu_1.default, { disableFieldSelection: disableFieldSelection, disableCharts: disableCharts, disableSaving: disableSaving, disableExpand: disableGrouping, additionalMoreButtons: additionalMoreButtons, fieldSelector: fieldSelector }))))), [
        myCss,
        selectionToolbar,
        showOpsMenu,
        fieldSelector,
        disableGrouping,
        disableFieldSelection,
        disableCharts,
        disableSaving,
        additionalMoreButtons,
    ]);
}
exports.DVLToolbar = DVLToolbar;
exports.default = DVLToolbar;
